<template>
    <wizard v-if="loaded"/>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import Wizard from '@/components/Wizard';

export default {
    components: {
        Wizard
    },
    data() {
        return {
            loaded: false
        }
    },
    methods: {
        ...mapActions('editor', ['LOAD_KINDS', 'LOAD_LIFECYCLES', 'LOAD_AREAS', 'LOAD_ORK_INFO', 'LOAD_QUALIFICATIONS']),
        ...mapActions('ork', ['LOAD_ORK_BY_ID']),
        ...mapMutations('ork', ['SET_ORK_ID']),
        ...mapMutations('common', ['TOGGLE_ALERT']),
        ...mapMutations('editor', ['SET_SELECTED_AREAS', 'GROUP_KINDS', 'CUR_STEP', 'RESET_QUALIFICATIONS']),
        ...mapMutations('listsForEditor', ['SET_ALL_KINDS_ITEMS']),
        
        async checkBeforeOpen() {
            this.CUR_STEP(1)
            const curOrkId = this.$route.params.id

            const localStorageData = JSON.parse(localStorage.getItem('ork.nark'))
            if (localStorageData) {
                const curOrkIdFromLocalStorage = localStorageData.ork.curOrkId

                if(curOrkIdFromLocalStorage != curOrkId) {
                    await this.SET_ALL_KINDS_ITEMS([])
                }
            }
            await this.RESET_QUALIFICATIONS();
            await this.SET_ORK_ID(curOrkId)
            await this.LOAD_ORK_INFO()
            await this.LOAD_KINDS()
            await this.LOAD_AREAS()
            const curKinds = Array.from(new Set(this.kinds.map(el => el.area_id)))
            const filteredAreas = this.areas.filter(el => curKinds.includes(el.id))
            await this.SET_SELECTED_AREAS(filteredAreas)
            await this.LOAD_QUALIFICATIONS();
            await this.GROUP_KINDS('area_id')
            if (this.lifecycles.length === 0) await this.LOAD_LIFECYCLES();

            this.$nextTick(() => {
                this.loaded = true
            });
        }
    },
    computed: {
        ...mapState('editor', ['areas', 'kinds', 'lifecycles']),
    },
    mounted() {
        const curOrkId = this.$route.params.id
        this.LOAD_ORK_BY_ID(curOrkId).then((status) => {
            if (status === 200) {
                this.checkBeforeOpen()
            } else if (status === 403) {
                this.TOGGLE_ALERT({open: true, text: 'У вас нет доступа к данной рамке'})
            } else {
                this.TOGGLE_ALERT({open: true, text: 'Такой рамки не существует'})
            }
        })
    },
    beforeRouteUpdate(to, from, next) {
        this.LOAD_ORK_BY_ID(to.params.id).then((status) => {
            if (status === 200) {
                next()
                this.checkBeforeOpen()
            } else if (status === 403) {
                this.TOGGLE_ALERT({open: true, text: 'У вас нет доступа к данной рамке'})
            } else {
                this.TOGGLE_ALERT({open: true, text: 'Такой рамки не существует'})
                next(false)
            }
        })
  }
}
</script>
